import { apolloClient } from '~/apollo-client';
import { LmiStatus } from '~/machines/review-form/types';
import { SelfAttestationData } from '~/screens/vnm-terms';
import { Flex_UpdateUserMutation, Flex_UpdateUserMutationVariables } from '~/typings/graphql';
import { UPDATE_USER } from './update-user-meta-data.queries';

export interface UpdateUserMetaDataParams {
  event?: string;
  meetingDetails?: {
    scheduledTime: string;
    scheduledDate: string;
  };
  lmiSelfAttestation?: {
    selfAttestationData?: SelfAttestationData | null;
    lmiStatus?: LmiStatus;
  };
  funnelCompletedTimeStamp?: string;
}

export type UpdateUserPreferencesResponse = void;

export const updateUser = async (
  userId: number,
  params: UpdateUserMetaDataParams,
): Promise<UpdateUserPreferencesResponse> => {
  await apolloClient.mutate<Flex_UpdateUserMutation, Flex_UpdateUserMutationVariables>({
    mutation: UPDATE_USER,
    variables: {
      id: userId,
      input: {
        metaData: { ...params },
      },
    },
  });
};
